module.exports = {
    config: require('./config'),
    version: require('./version'),
    procedures: {
        lead_list: {
            definition: require('./lead_list/definition.json'),
            mock_data: require('./lead_list/mock_data.json')
        },
        listing_create: {
            definition: require('./listing_create/definition.json'),
            mock_data: require('./listing_create/mock_data.json')
        },
        listing_inventory_item_group_create: {
            definition: require('./listing_inventory_item_group_create/definition.json'),
            mock_data: require('./listing_inventory_item_group_create/mock_data.json')
        },
        listing_inventory_item_group_read: {
            definition: require('./listing_inventory_item_group_read/definition.json'),
            mock_data: require('./listing_inventory_item_group_read/mock_data.json')
        },
        listing_inventory_item_group_update: {
            definition: require('./listing_inventory_item_group_update/definition.json'),
            mock_data: require('./listing_inventory_item_group_update/mock_data.json')
        },
        listing_list: {
            definition: require('./listing_list/definition.json'),
            mock_data: require('./listing_list/mock_data.json')
        },
        listing_read: {
            definition: require('./listing_read/definition.json'),
            mock_data: require('./listing_read/mock_data.json')
        },
        listing_update: {
            definition: require('./listing_update/definition.json'),
            mock_data: require('./listing_update/mock_data.json')
        },
        lead_create: {
            definition: require('./lead_create/definition.json'),
            mock_data: require('./lead_create/mock_data.json')
        },
        lead_read: {
            definition: require('./lead_read/definition.json'),
            mock_data: require('./lead_read/mock_data.json')
        },
        lead_update: {
            definition: require('./lead_update/definition.json'),
            mock_data: require('./lead_update/mock_data.json')
        },
        lead_note_create: {
            definition: require('./lead_note_create/definition.json'),
            mock_data: require('./lead_note_create/mock_data.json')
        },
        lead_note_list: {
            definition: require('./lead_note_list/definition.json'),
            mock_data: require('./lead_note_list/mock_data.json')
        },
        action_form_list: {
            definition: require('./action_form_list/definition.json'),
            mock_data: require('./action_form_list/mock_data.json')
        },
        action_form_read: {
            definition: require('./action_form_read/definition.json'),
            mock_data: require('./action_form_read/mock_data.json')
        },
        action_form_create: {
            definition: require('./action_form_create/definition.json'),
            mock_data: require('./action_form_create/mock_data.json')
        },
        action_form_update: {
            definition: require('./action_form_update/definition.json'),
            mock_data: require('./action_form_update/mock_data.json')
        },
        action_form_action_type_list: {
            definition: require('./action_form_action_type_list/definition.json'),
            mock_data: require('./action_form_action_type_list/mock_data.json')
        },
        action_form_field_type_list: {
            definition: require('./action_form_field_type_list/definition.json'),
            mock_data: require('./action_form_field_type_list/mock_data.json')
        },
        promotion_current_list: {
            definition: require('./promotion_current_list/definition.json'),
            mock_data: require('./promotion_current_list/mock_data.json')
        },
        promotion_list: {
            definition: require('./promotion_list/definition.json'),
            mock_data: require('./promotion_list/mock_data.json')
        },
        ad_channel_list:{
            definition: require('./ad_channel_list/definition.json'),
            mock_data: require('./ad_channel_list/mock_data.json')
        },
        ad_create:{
            definition: require('./ad_create/definition.json'),
            mock_data: require('./ad_create/mock_data.json')
        },
        ad_list:{
            definition: require('./ad_list/definition.json'),
            mock_data: require('./ad_list/mock_data.json')
        },
        ad_read:{
            definition: require('./ad_read/definition.json'),
            mock_data: require('./ad_read/mock_data.json')
        },
        ad_update:{
            definition: require('./ad_update/definition.json'),
            mock_data: require('./ad_update/mock_data.json')
        },
        ad_group_create:{
            definition: require('./ad_group_create/definition.json'),
            mock_data: require('./ad_group_create/mock_data.json')
        },
        ad_group_list:{
            definition: require('./ad_group_list/definition.json'),
            mock_data: require('./ad_group_list/mock_data.json')
        },
        ad_group_period_create:{
            definition: require('./ad_group_period_create/definition.json'),
            mock_data: require('./ad_group_period_create/mock_data.json')
        },
        ad_group_period_list:{
            definition: require('./ad_group_period_list/definition.json'),
            mock_data: require('./ad_group_period_list/mock_data.json')
        },
        ad_group_period_update:{
            definition: require('./ad_group_period_update/definition.json'),
            mock_data: require('./ad_group_period_update/mock_data.json')
        },
        ad_group_read:{
            definition: require('./ad_group_read/definition.json'),
            mock_data: require('./ad_group_read/mock_data.json')
        },
        ad_group_update:{
            definition: require('./ad_group_update/definition.json'),
            mock_data: require('./ad_group_update/mock_data.json')
        },
        ad_location_campaign_create:{
            definition: require('./ad_location_campaign_create/definition.json'),
            mock_data: require('./ad_location_campaign_create/mock_data.json')
        },
        ad_location_campaign_list:{
            definition: require('./ad_location_campaign_list/definition.json'),
            mock_data: require('./ad_location_campaign_list/mock_data.json')
        },
        ad_location_campaign_update:{
            definition: require('./ad_location_campaign_update/definition.json'),
            mock_data: require('./ad_location_campaign_update/mock_data.json')
        },
        ad_location_create:{
            definition: require('./ad_location_create/definition.json'),
            mock_data: require('./ad_location_create/mock_data.json')
        },
        ad_location_list:{
            definition: require('./ad_location_list/definition.json'),
            mock_data: require('./ad_location_list/mock_data.json')
        },
        ad_location_read:{
            definition: require('./ad_location_read/definition.json'),
            mock_data: require('./ad_location_read/mock_data.json')
        },
        ad_location_update:{
            definition: require('./ad_location_update/definition.json'),
            mock_data: require('./ad_location_update/mock_data.json')
        },
        shorturl_create:{
            definition: require('./shorturl_create/definition.json'),
            mock_data: require('./shorturl_create/mock_data.json')
        },
        shorturl_read:{
            definition: require('./shorturl_read/definition.json'),
            mock_data: require('./shorturl_read/mock_data.json')
        }
    }
};